
import { postMessageToWindow } from './index';

export const initiateTitleAlert = ({senderName = 'Bot', event, type}) => {
    postMessageToWindow(
        {
          type,
          event,
          senderName
        },
        '*'
      );

};


export const abortTitleAlert = ({event, type}) => {
    postMessageToWindow(
        {
          type,
          event,
        },
        '*'
      );
}